import Button from 'tailwind-components/Button/Button';
import React, { useEffect, useRef, useState } from 'react';
import icons from 'constants/icons';
import propTypes from 'prop-types';
import style from './tabs.module.scss';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const TabSizes = {
  small: style.small,
  medium: ''
};

const Warning = icons['warning'];

function Tabs({
  headers = [],
  size = 'medium',
  children,
  floatingHeader,
  className,
  bottomLine,
  initialTab = 1,
  setCurrentTab = undefined,
  handleTabClick = undefined
}) {
  const [activeTab, setActiveTab] = useState(initialTab);
  const [scrollLeftDisabled, setDisableScrollLeft] = useState(true);
  const [scrollRightDisabled, setDisableScrollRight] = useState(false);
  const [scrollable, setScrollable] = useState(false);
  const headersRef = useRef(null);

  const handleScrollCaptureLeft = () => {
    if (headersRef.current) {
      const headersScrollWidth = headersRef.current.scrollWidth;
      const headerScrollLeft = headersRef.current.scrollLeft;
      const headersOffsetWidth = headersRef.current.offsetWidth;
      if (headerScrollLeft > 0) {
        if (headersScrollWidth - headersOffsetWidth === headerScrollLeft)
          setDisableScrollRight(true);
        else setDisableScrollRight(false);

        setDisableScrollLeft(false);
      } else {
        if (headersScrollWidth - headersOffsetWidth === headerScrollLeft) {
          setDisableScrollRight(true);
          setScrollable(false);
        } else {
          setDisableScrollRight(false);
          setScrollable(true);
        }
        setDisableScrollLeft(true);
      }
    }
  };

  useEffect(() => {
    handleScrollCaptureLeft();
  }, [headersRef]);

  useEffect(() => {
    window.addEventListener('resize', handleScrollCaptureLeft);
    return () => {
      window.removeEventListener('resize', handleScrollCaptureLeft);
    };
  });

  const handleScrollLeft = () => {
    if (headersRef.current) {
      headersRef.current.scrollLeft -= 150;
    }
  };
  const handleScrollRight = () => {
    if (headersRef.current) {
      headersRef.current.scrollLeft += 150;
    }
  };
  return (
    <div className={`${style.tabs}  ${className}`}>
      <div
        className={`${style.headersContainer} ${
          style.headersContainerFloating
        } ${scrollable ? style.scrollable : ''} ${
          floatingHeader ? style.floatingHeader : ''
        }`}
      >
        <div
          ref={headersRef}
          onScrollCapture={handleScrollCaptureLeft}
          className={`${style.headers} ${style.floatingHeaders} ${TabSizes[size]}  tabsHeader`}
        >
          {headers.map((header, i) => (
            <button
              key={headers[i]}
              className={`${style.header} ${
                activeTab === i
                  ? header === 'Action Needed'
                    ? style.activeActionNeeded
                    : style.active
                  : ''
              }`}
              onClick={() => {
                setActiveTab(i);
                if (setCurrentTab) setCurrentTab(headers[i]);
                if (handleTabClick) handleTabClick(headers[i]);
              }}
            >
              {header === 'Action Needed' ? (
                <div className={style.actionsNeeded}>
                  <Warning fontSize='small' />
                  <span>{header}</span>
                </div>
              ) : (
                header
              )}
            </button>
          ))}
        </div>
      </div>
      <div
        className={`${style.headersContainer} ${
          scrollable ? style.scrollable : ''
        }`}
      >
        <div
          className={`${style.scrollLeft} ${
            scrollLeftDisabled ? style.disabled : ''
          }`}
        >
          <Button
            icon={<ChevronLeft />}
            size='small'
            rounded='large'
            variant='transparent'
            onClick={handleScrollLeft}
          />
        </div>
        <div
          ref={headersRef}
          onScrollCapture={handleScrollCaptureLeft}
          className={`${style.headers} ${TabSizes[size]}  tabsHeader`}
        >
          {headers.map((header, i) => (
            <button
              key={headers[i]}
              className={`${style.header} ${
                activeTab === i
                  ? header === 'Action Needed'
                    ? style.activeActionNeeded
                    : style.active
                  : ''
              }`}
              onClick={() => {
                setActiveTab(i);
                if (setCurrentTab) setCurrentTab(headers[i]);
                if (handleTabClick) handleTabClick(headers[i]);
              }}
            >
              {header === 'Action Needed' ? (
                <div className={style.actionsNeeded}>
                  <Warning fontSize='small' />
                  <span>{header}</span>
                </div>
              ) : (
                header
              )}
            </button>
          ))}
        </div>
        <div
          className={`${style.scrollRight} ${
            scrollRightDisabled ? style.disabled : ''
          }`}
        >
          <Button
            icon={<ChevronRight />}
            size='small'
            rounded='large'
            variant='transparent'
            onClick={handleScrollRight}
          />
        </div>
      </div>
      {bottomLine === true ? <hr /> : null}
      <div>
        {children.filter(Boolean).map((child, i) => (
          <>
            {activeTab === i ? (
              <span key={headers[i]} className={`${style.body} `}>
                {child}
              </span>
            ) : null}
          </>
        ))}
      </div>
    </div>
  );
}

Tabs.propTypes = {
  headers: propTypes.array,
  size: propTypes.string,
  children: propTypes.array,
  className: propTypes.string,
  floatingHeader: propTypes.bool,
  bottomLine: propTypes.bool,
  initialTab: propTypes.number,
  setCurrentTab: propTypes.func,
  handleTabClick: propTypes.func
};

export default Tabs;
